import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

/** Paleta primária VetorIT (substitui emerald/green do Aura) */
const vetorPrimary = {
  50: '#fef6f0',
  100: '#fde9dc',
  200: '#fad0b3',
  300: '#f5b085',
  400: '#ec9258',
  500: '#e1742e',
  600: '#c95e1e',
  700: '#ad4f1a',
  800: '#8d4116',
  900: '#6f3413',
  950: '#3d1c0a'
};

/** Botão filled — reutilizado em severity success */
const buttonSuccessFilled = {
  background: '{primary.color}',
  hoverBackground: '{primary.hover.color}',
  activeBackground: '{primary.active.color}',
  borderColor: '{primary.color}',
  hoverBorderColor: '{primary.hover.color}',
  activeBorderColor: '{primary.active.color}',
  color: '#ffffff',
  hoverColor: '#ffffff',
  activeColor: '#ffffff',
  focusRing: {
    color: '{primary.color}',
    shadow: 'none'
  }
};

/** Tag / toast / message — success com tons primários */
const tagSuccessLight = {
  background: '{primary.100}',
  color: '{primary.700}'
};

const messageSuccessLight = {
  background: 'color-mix(in srgb, {primary.50}, transparent 5%)',
  borderColor: '{primary.200}',
  color: '{primary.600}',
  shadow: '0px 4px 8px 0px color-mix(in srgb, {primary.500}, transparent 96%)',
  closeButton: {
    hoverBackground: '{primary.100}',
    focusRing: {
      color: '{primary.600}',
      shadow: 'none'
    }
  },
  outlined: {
    color: '{primary.600}',
    borderColor: '{primary.600}'
  },
  simple: {
    color: '{primary.600}'
  }
};

const toastSuccessLight = {
  background: 'color-mix(in srgb, {primary.50}, transparent 5%)',
  borderColor: '{primary.200}',
  color: '{primary.600}',
  detailColor: '{surface.700}',
  shadow: '0px 4px 8px 0px color-mix(in srgb, {primary.500}, transparent 96%)',
  closeButton: {
    hoverBackground: '{primary.100}',
    focusRing: {
      color: '{primary.600}',
      shadow: 'none'
    }
  }
};

/** Info — azul Avalara */
const buttonInfoFilled = {
  background: '#059ad2',
  hoverBackground: '#0486b8',
  activeBackground: '#03739f',
  borderColor: '#059ad2',
  hoverBorderColor: '#0486b8',
  activeBorderColor: '#03739f',
  color: '#ffffff',
  hoverColor: '#ffffff',
  activeColor: '#ffffff',
  focusRing: {
    color: '#059ad2',
    shadow: 'none'
  }
};

export const VetorITPreset = definePreset(Aura, {
  semantic: {
    primary: vetorPrimary
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            success: buttonSuccessFilled,
            info: buttonInfoFilled
          }
        }
      }
    },
    tag: {
      colorScheme: {
        light: {
          success: tagSuccessLight
        },
        dark: {
          success: {
            background: 'color-mix(in srgb, {primary.500}, transparent 84%)',
            color: '{primary.300}'
          }
        }
      }
    },
    message: {
      colorScheme: {
        light: {
          success: messageSuccessLight
        }
      }
    },
    toast: {
      colorScheme: {
        light: {
          success: toastSuccessLight
        }
      }
    }
  }
});
